var swiper1 = document.getElementById('swiper-featured-1');
var swiper2 = document.getElementById('swiper-featured-2');
var title1 = document.getElementById('title-1');
var title2 = document.getElementById('title-2');

const toggle = document.querySelectorAll('.toggle');
const active = document.querySelectorAll('.nav-links .toggle');

const swiperFeatured1 = new Swiper('.swiper.featured-1', {
  loadPrevNext: true,
  slidesPerView: 1.5,
  spaceBetween: 18,
  loop: true,
  centeredSlides: true,
  lazy: true,
  breakpoints: {
    750: {
      slidesPerView: 4,
      spaceBetween: 30,
      loop: false,
      centeredSlides: false,
      preloadImages: false,
    }
  }
});

const swiperFeatured2 = new Swiper('.swiper.featured-2', {
  loadPrevNext: true,
  slidesPerView: 1.5,
  spaceBetween: 18,
  init: false,
  loop: true,
  centeredSlides: true,
  lazy: true,
  breakpoints: {
    750: {
      slidesPerView: 4,
      spaceBetween: 30,
      loop: false,
      centeredSlides: false,
      preloadImages: false,
    }
  }
});

document.addEventListener('click', function (event) {
	if (!event.target.matches('#nav-2')) return;
  swiperFeatured2.init();
  toggle.forEach(el => {
    el.classList.toggle('hide');
  });
  active.forEach(el2 => {
    el2.classList.toggle('active');
  });
}, false);

document.addEventListener('click', function (event) {
	if (!event.target.matches('#nav-1')) return;
  toggle.forEach(el => {
    el.classList.toggle('hide');
  });
  active.forEach(el2 => {
    el2.classList.toggle('active');
  });
}, false);